const apiUrl = process.env.NODE_ENV !== 'production'
  ? 'https://devapi.joinnus.com/v1'
  : 'https://api.joinnus.com/v1'
export default {
  data () {
    return {
      apiUrl
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/globalMix.js